export { default as Base } from './base';
export { default as Circle } from './circle';
export { default as Ellipse } from './ellipse';
export { default as Image } from './image';
export { default as Line } from './line';
export { default as Marker } from './marker';
export { default as Path } from './path';
export { default as Polygon } from './polygon';
export { default as Polyline } from './polyline';
export { default as Rect } from './rect';
export { default as Text } from './text';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g-canvas@0.4.14@@antv/g-canvas/esm/shape/index.js
// module id = null
// module chunks = 